export default __webpack_public_path__ + "static/media/efficient-teamwork.9666d7ed.svg";